<template>
  <div>
    <img :src="promotion.image" class="md:w-1/2 lg:w-auto" alt="">
      <div class="pl-4 md:pl-8 lg:pl-6 pr-14 py-6 bg-black text-white md:flex flex-col justify-center bottom-clip-small">
        <div class="heading text-2xl md:text-[32px] mb-1 lg:mb-2">{{ promotion.title }}</div>
        <div class="md:text-lg" v-html="promotion.content"></div>
        <a :href="promotion.linkUrl" class="arrow-link arrow-link-icon-blue mt-3 promotion-cta" :data-promotioncta="promotioncta" :target="promotion.linkTarget">
          <span class="text-lg">{{ promotion.linkLabel }}</span>
        </a>
      </div>
  </div>
</template>

<script setup>
const props = defineProps([
  'promotion',
  'promotioncta',
]);
</script>

